// services/reportGenerator.js
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
// Date Fns is used to format the dates we receive
// from our API call
import KsKlogo from '../components/layout/logoKSK2.png'
import moment from "moment";
const font = require("../fonts/polish-fonts");

function seconds2time(seconds) {
  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor((seconds - (hours * 3600)) / 60);
  seconds = seconds - (hours * 3600) - (minutes * 60);
  var time = "";

  if (hours !== 0) {
    time = hours + "h ";
  }
  if (minutes !== 0 || time !== "") {
    minutes = (minutes < 10 && time !== "") ? "0" + minutes : String(minutes);
    time += minutes + "min ";
  }
  if (time === "") {
    time = seconds + "s";
  }
  else {
    time += (seconds < 10) ? "0" + seconds : String(seconds) + "s";
  }
  return time;
}

// define a generatePDF function that accepts a tickets argument
const generatePDFParking = parkings => {

  var docFont = font.ptsans;

  const input = document.getElementById(parkings.chart);

  /*html2canvas(input)
    .then((canvas) => {
      document.body.appendChild(canvas)
      const imgData = canvas.toDataURL('image/png')
      const doc = new jsPDF();
      doc.addImage(
        imgData,
        "png",
        10,
        23.5,
        190,
        250
        );
      doc.save("test.pdf");
    });
*/
  // initialize jsPDF
  html2canvas(input , {
    onclone: function (clonedDoc) {
      clonedDoc.getElementById(parkings.chart).style.display = 'block';
    }

  },{width:277,height:300})
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png');

  if (parkings.id === 1)
  {
  const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

  doc.addFileToVFS('calibri-normal.ttf', docFont);
  doc.addFont('calibri-normal.ttf', 'calibri', 'normal');

  doc.setFont('calibri');

  // define the columns we want and their titles
  const tableColumnMainStats = ["Ile wjazdów", "Ile zjazdów", "Ile skonczonych parkowan", "Sredni czas parkowania", "% wolne", "% zajete", "Min wolne", "Max wolne", "Min zajete", "Max zajete"];
  // define an empty array of rows
  const tableRowsMainStats = [];

  const tableColumnAllEntries = ["ID", "Adres", "Czas trwania", "Opis", "Start", "Stop"];
  // define an empty array of rows
  const tableRowsAllEntries = [];

  const tableColumnEntries = ["ID", "Adres", "Opis", "Timestamp"];

  const tableRowsEntries = [];

  // for each ticket pass all its data into an array
  console.log(parkings);

  const parkingMainStats = [

    parkings.parkingStats[0].ileWjazdow,
    parkings.parkingStats[0].ileZjazdow,
    parkings.parkingStats[0].ilePojazdow,
    parkings.parkingStats[0].sredniCzasParkowania,
    parkings.parkingStats[0].procentWolne,
    parkings.parkingStats[0].procentZajete,
    parkings.parkingStats[0].minWolne,
    parkings.parkingStats[0].maxWolne,
    parkings.parkingStats[0].minZajete,
    parkings.parkingStats[0].maxZajete
  ];

  console.log(parkingMainStats);
  tableRowsMainStats.push(parkingMainStats);
  parkings.parkingStats[0].detectorDurations.forEach(parking => {

    const parkingAllEntries = [
      parking.id,
      parking.address,
      seconds2time(parking.duration),
      parking.type,
      moment.unix(parking.start).format("HH:mm:ss - DD/MM/YYYY"),
      moment.unix(parking.stop).format("HH:mm:ss - DD/MM/YYYY"),
    ];
    tableRowsAllEntries.push(parkingAllEntries);
    console.log(parkingAllEntries)
  /*  const parkingData = [
      parking.id,
      parking.parkingName,
      parking.description,
      parking.userID,
      parking.gpsLatitude,
      parking.gpsLongtitude,
      // called date-fns to format the date on the ticket
      format(new Date(parking.updated_at), "yyyy-MM-dd")
    ];
    console.log(parking);*/
    // push each tickcet's info into a row
    //



  });

    parkings.parkingStats[0].entriesLeaves.forEach(parking => {
    const parkingAllEntries = [
      parking.id,
      parking.address,
      parking.type,
      moment.unix(parking.timestamp).format("HH:mm:ss - DD/MM/YYYY"),
     ];
    tableRowsEntries.push(parkingAllEntries);
    console.log(parkingAllEntries)
  });



  console.log("test");

  doc.setFontSize(20);
  // startY is basically margin-top

  doc.text("Raport z parkingu:", 105, 100, "center");
  doc.setFontSize(25);
  doc.text(parkings.parkingName, 105, 115, "center");
  doc.setFontSize(14);
  doc.text("(" + parkings.description + ")", 105, 123, "center");

  doc.setFontSize(14);
  doc.text(" od  " + moment(parkings.parkingStats[0].dateMin).format("HH:mm:ss - DD/MM/YYYY") + "  do  " + moment(parkings.parkingStats[0].dateMax).format("HH:mm:ss - DD/MM/YYYY"), 105, 135, "center");

  doc.addImage(
    KsKlogo,
    "PNG",
    15,
    236,
    180,
    44
  );

  doc.addPage('a4','p');
  doc.autoTable(tableColumnMainStats, tableRowsMainStats, { startY: 10 });
  const date = Date().split(" ");
  // we use a date string to generate our filename.
  const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
  // ticket title. and margin-top + margin-left


  doc.setFontSize(6);
  doc.autoTable(tableColumnEntries, tableRowsEntries, { startY: 35 });

  doc.addPage('a4', 'p');
  doc.setFontSize(6);
  doc.autoTable(tableColumnAllEntries, tableRowsAllEntries, { startY: 35 });
  /*doc.addPage('a4','l')
  doc.addImage(
    'https://ecsmedia.pl/c/jerry-fabrics-kot-kotek-kotki-koc-kocyk-120x150-cieply-b-iext74314736.jpg',
    'JPEG',
    23.5,
    10,
    250,
    190
    );*/
  doc.addPage('a4', 'l');

  doc.setFontSize(14);

  if (parkings.parkingId <=3)
  {
    doc.text("Wjazdy/wyjazdy w interwale godzinowym", 20, 30);

    //document.body.appendChild(canvas)
    doc.addImage(
      imgData,
      "png",
      10,
      40,
      277,
      340
    );
    doc.addPage('a4', 'l');
    doc.addImage(
      imgData,
      "png",
      10,
      -154,
      277,
      340
    );
    doc.text("Zajetosc w interwale 15-minutowym", 20, 30);
    //document.body.appendChild(canvas)

  }
  else
  {
  doc.text("Wjazdy/wyjazdy w interwale godzinowym",20,30);

      //document.body.appendChild(canvas)
      doc.addImage(
        imgData,
        "png",
        10,
        40,
        277,
        150
      );
      }
      var pageCount = doc.internal.getNumberOfPages(); //Total Page Number
      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i);
        let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
        doc.setFontSize(12);
        doc.text('strona: ' + pageCurrent + '/' + pageCount, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 10);
      }


      doc.save(`report_${dateStr}.pdf`);
      }
      else if (parkings.id === 2)
      {
        const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

        doc.addFileToVFS('calibri-normal.ttf', docFont);
        doc.addFont('calibri-normal.ttf', 'calibri', 'normal');

        doc.setFont('calibri');

        // define the columns we want and their titles
        const tableColumnMainStats = ["Ile pojazdow", "Sredni czas parkowania", "% wolne", "% zajete", "Min wolne", "Max wolne", "Min zajete", "Max zajete"];
        // define an empty array of rows
        const tableRowsMainStats = [];

        const tableColumnAllEntries = ["ID", "Czas Trwania", "Zajetosc", "Start","Stop"];
        // define an empty array of rows
        const tableRowsAllEntries = [];

        // for each ticket pass all its data into an array
        console.log(parkings);

        const parkingMainStats = [
          //parkings.parkingStats[0].ileWjazdow,
          //parkings.parkingStats[0].ileZjazdow,
          parkings.parkingStats[0].ilePojazdow,
          parkings.parkingStats[0].sredniCzasParkowania,
          parkings.parkingStats[0].procentWolne,
          parkings.parkingStats[0].procentZajete,
          parkings.parkingStats[0].minWolne,
          parkings.parkingStats[0].maxWolne,
          parkings.parkingStats[0].minZajete,
          parkings.parkingStats[0].maxZajete
        ];

        console.log(parkingMainStats);
        tableRowsMainStats.push(parkingMainStats);
        parkings.parkingStats[0].entriesExitsByHours.forEach(parking => {

          const parkingAllEntries = [
            parking.id,
            parking.duration,
            parking.type,
            parking.start,
            parking.stop
          ];
          tableRowsAllEntries.push(parkingAllEntries);
          console.log(parkingAllEntries)
          /*  const parkingData = [
              parking.id,
              parking.parkingName,
              parking.description,
              parking.userID,
              parking.gpsLatitude,
              parking.gpsLongtitude,
              // called date-fns to format the date on the ticket
              format(new Date(parking.updated_at), "yyyy-MM-dd")
            ];
            console.log(parking);*/
          // push each tickcet's info into a row
          //



        });

        console.log("test");
        doc.setFontSize(20);
        // startY is basically margin-top

        doc.text("Raport czujnika nr. " + parkings.deviceId, 105, 120,"center");

        doc.setFontSize(14);
        doc.text(" od  " + moment(parkings.parkingStats[0].dateMin).format("HH:mm:ss - DD/MM/YYYY") + "  do  " + moment(parkings.parkingStats[0].dateMax).format("HH:mm:ss - DD/MM/YYYY"),105 , 135, "center");

        doc.addImage(
          KsKlogo,
          "PNG",
          15,
          236,
          180,
          44
        );
        // startY is basically margin-top
        doc.addPage('a4', 'p');
        doc.autoTable(tableColumnMainStats, tableRowsMainStats, { startY: 10 });
        const date = Date().split(" ");
        // we use a date string to generate our filename.
        const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
        // ticket title. and margin-top + margin-left

        doc.setFontSize(6);
        doc.autoTable(tableColumnAllEntries, tableRowsAllEntries, { startY: 35 });
        /*doc.addPage('a4','l')
        doc.addImage(
          'https://ecsmedia.pl/c/jerry-fabrics-kot-kotek-kotki-koc-kocyk-120x150-cieply-b-iext74314736.jpg',
          'JPEG',
          23.5,
          10,
          250,
          190
          );*/
        doc.addPage('a4', 'l');

        doc.setFontSize(14);
        //document.body.appendChild(canvas)
        doc.text("Zmiana stanu czujnika i baterii w czasie", 20, 30);

        //document.body.appendChild(canvas)
        doc.addImage(
          imgData,
          "png",
          10,
          40,
          277,
          150
        );

        pageCount = doc.internal.getNumberOfPages(); //Total Page Number
        for (let i = 0; i < pageCount; i++) {
          doc.setPage(i);
          let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
          doc.setFontSize(12);
          doc.text('strona: ' + pageCurrent + '/' + pageCount, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 10);
        }


        doc.save(`report_${dateStr}.pdf`);


      }
      else if (parkings.id === 3)
      {
        const doc = new jsPDF({ filters: ["ASCIIHexEncode"] });

        doc.addFileToVFS('calibri-normal.ttf', docFont);
        doc.addFont('calibri-normal.ttf', 'calibri', 'normal');

        doc.setFont('calibri');

        const tableColumn = ["ID czujnika", "Stan baterii", "Ostatni status"];
        const tableColumn2 = ["ID",	"ID czujnika",	"Przedostatnia ramka",	"Ostatnia ramka",	"Różnica",	"Data końca",	"Uwaga"];

        const rowsbattery = [];
        const rowstime = [];
        const rowshistory = [];

        parkings.parkingStats[0].battery.forEach(parking => {

          const Entries = [
            parking.address,
            parking.battery,
            moment.unix(parking.timestamp/1000).format("HH:mm:ss - DD/MM/YYYY"),
          ];
          rowsbattery.push(Entries);
          console.log(Entries)
        });

        parkings.parkingStats[0].time.forEach(parking => {

          const Entries = [
            parking.address,
            parking.battery,
            moment.unix(parking.timestamp/1000).format("HH:mm:ss - DD/MM/YYYY"),
          ];
          rowstime.push(Entries);
          console.log(Entries)
        });

        parkings.parkingStats[0].err0.forEach(parking => {

          const Entries = [
            parking.index,
            parking.address,
            moment.unix(parking.first / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            moment.unix(parking.second / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.difference,
            moment.unix(parking.date / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.error
          ];
          rowshistory.push(Entries);
          console.log(Entries)
        });
        parkings.parkingStats[0].err2.forEach(parking => {

          const Entries = [
            parking.index,
            parking.address,
            moment.unix(parking.first / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            moment.unix(parking.second / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.difference,
            moment.unix(parking.date / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.error
          ];
          rowshistory.push(Entries);
          console.log(Entries)
        });
        parkings.parkingStats[0].err3.forEach(parking => {

          const Entries = [
            parking.index,
            parking.address,
            moment.unix(parking.first / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            moment.unix(parking.second / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.difference,
            moment.unix(parking.date / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.error
          ];
          rowshistory.push(Entries);
          console.log(Entries)
        });
        parkings.parkingStats[0].err4.forEach(parking => {

          const Entries = [
            parking.index,
            parking.address,
            moment.unix(parking.first / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            moment.unix(parking.second / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.difference,
            moment.unix(parking.date / 1000).format("HH:mm:ss - DD/MM/YYYY"),
            parking.error
          ];
          rowshistory.push(Entries);
          console.log(Entries)
        });

        const date = Date().split(" ");
        // we use a date string to generate our filename.
        const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];

        console.log("test");

        doc.setFontSize(20);
        // startY is basically margin-top

        doc.text("Raport z czujnikami nie działającymi poprawnie", 105, 100, "center");
        doc.setFontSize(14);
        doc.text("(Raport obejmuje wszystkie parkingi)", 105, 115, "center");
        doc.text("Wygenerowano dnia: "+moment(Date()).format("HH:mm:ss - DD/MM/YYYY"), 105, 125, "center");
        doc.text("Dane historyczne: od " + moment(parkings.dateMin).format("HH:mm:ss - DD/MM/YYYY") + " do " + moment(parkings.dateMax).format("HH:mm:ss - DD/MM/YYYY"), 105, 135, "center");

        doc.addImage(
          KsKlogo,
          "PNG",
          15,
          236,
          180,
          44
        );

        doc.addPage('a4', 'p');
        doc.text("Czujniki mające niski poziam baterii", 15, 30);
        doc.autoTable(tableColumn, rowsbattery, { startY: 40 });

        doc.addPage('a4', 'p');
        doc.text("Czujniki, które nie odpowiadają", 15, 30);
        doc.autoTable(tableColumn, rowstime, { startY: 40 });

        doc.addPage('a4', 'p');
        doc.text("Dane Historyczne Czujników", 15, 30);
        doc.text("Czujniki nie działające prawidłowo w danym okresie", 15, 38);
        doc.autoTable(tableColumn2, rowshistory, { startY: 48, styles: { font: 'calibri' }, });

        pageCount = doc.internal.getNumberOfPages(); //Total Page Number
        for (let i = 0; i < pageCount; i++) {
          doc.setPage(i);
          let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
          doc.setFontSize(12);
          doc.text('strona: ' + pageCurrent + '/' + pageCount, doc.internal.pageSize.width - 40, doc.internal.pageSize.height - 10);
        }


        doc.save(`report_${dateStr}.pdf`);


      }


    });
  // we define the name of our PDF file.


};

export default generatePDFParking
